define('views/modules/template/edit/calendar/personal-data/form/personal-data-details-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // parent view
    'views/modules/calendar/personal-data/item/form/personal-data-details-form',
    // services
    'services/i18n',
    // template
    'text!templates/modules/template/edit/calendar/personal-data/personal-data-details-form.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // parent view
    VPersonalDataDetailsForm,
    // services
    i18n,
    // template
    TTemplatePersonalDataDetailsForm
) {

    var VTemplatePersonalDataDetailsForm = VPersonalDataDetailsForm.extend({
        template: TTemplatePersonalDataDetailsForm,

        onCustomDataChange: function(model, value) {
            var dataType = this.collection.get(value);
            this.currentPersonalData.set('unit', null);
            if (dataType) {
                this.currentPersonalData.reset(dataType.attributes);
                this.currentPersonalData.set('unit', i18n.t(dataType.getUserUnit()));
                this.model.set({
                    unit: dataType.getUserUnit(),
                    name: dataType.get('name')
                });
            }
        },
    });

    return VTemplatePersonalDataDetailsForm;

});

